export default "__VITE_ASSET__b824e8eb__"